// CDM dataset Ref 14 — "Other Major Diagnoses (excl. CDM diagnoses)".
// Multi-select + an "Other" free-text option. Values match the BE
// `clinicalData.otherMajorDiagnoses.diagnoses` enum (CDM submit DTO).
export const otherMajorDiagnosisItems = [
  {
    field: "myocardialInfarction",
    id: "MYOCARDIAL_INFARCTION",
    name: "Myocardial Infarction",
  },
  { field: "dementia", id: "DEMENTIA", name: "Dementia" },
  {
    field: "cancerStage2Plus",
    id: "CANCER_STAGE_2_PLUS",
    name: "Cancer (Stage 2 or Higher)",
  },
  {
    field: "seriousMobilityIssues",
    id: "SERIOUS_MOBILITY_ISSUES",
    name: "Serious Mobility Issues",
  },
  {
    field: "chronicKidneyDisease",
    id: "CHRONIC_KIDNEY_DISEASE",
    name: "Chronic Kidney Disease",
  },
  {
    field: "significantMentalIllness",
    id: "SIGNIFICANT_MENTAL_ILLNESS",
    name: "Significant Mental Illness (Current)",
  },
  {
    field: "hypertensionOnTreatment",
    id: "HYPERTENSION_ON_TREATMENT",
    name: "Hypertension (HTN) - On Treatment",
  },
  {
    field: "inflammatoryArthritis",
    id: "INFLAMMATORY_ARTHRITIS",
    name: "Inflammatory Arthritis",
  },
];
